/* eslint no-console: 0 */
import { I18n } from 'aws-amplify'
import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useAuth } from '../../../../presentation/contexts/auth'
import HelperAmplify from '../../../../presentation/helpers/helper-amplify'
import RecoveryPassword from '../../../../presentation/pages/amplify/recovery-password'

const MakeRecoveryPassword = () => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const [code, setCode] = useState<string | null>(null)
  const history = useHistory()
  const { emailToRecoveryPassword } = useAuth()

  const dataFormCode = [
    {
      items: [
        {
          name: 'code',
          component: 'Input',
          value: '',
          placeholder: 'Digite aqui',
          type: 'number',
          title: 'Código',
          label: 'Código',
          required: true,
          validations: 'codeRequired',
        },
        {
          name: 'button',
          component: 'Button',
          title: 'Prosseguir',
          submittingText: 'Prosseguindo...',
        },
      ],
    },
  ]

  const dataForm = [
    {
      items: [
        {
          name: 'password',
          component: 'InputPassword',
          value: '',
          placeholder: 'Digite aqui',
          type: 'password',
          title: 'Nova Senha',
          label: 'Nova Senha',
          required: true,
          secureTextEntry: true,
          passwordInput: true,
          validations: 'passwordMinRequired',
          style: { marginBottom: '15px' },
        },
        {
          name: 'confirmPassword',
          component: 'InputPassword',
          value: '',
          placeholder: 'Digite aqui',
          type: 'password',
          title: 'Confirmar Senha',
          label: 'Confirmar Senha',
          required: true,
          secureTextEntry: true,
          passwordInput: true,
          validations: 'confirmPassword',
        },
        {
          name: 'button',
          component: 'Button',
          title: 'Confirmar',
          submittingText: 'Confirmando...',
        },
      ],
    },
  ]

  const onSubmitCode = async (values:any): Promise<void> => {
    const { code: codeValue } = values

    setCode(codeValue)
  }

  const onSubmit = async (values:any): Promise<void> => {
    const { password } = values

    try {
      await HelperAmplify.recoveryPassword(emailToRecoveryPassword, code, password)
      history.push('/recovery-password')
    } catch (error: any) {
      console.log({ error })
      const msg = I18n.get(error.name)
      setErrorMessage(msg)
    }
  }

  const goBack = () => {
    if (code) {
      setCode(null)
    } else {
      history.goBack()
    }
  }

  return (
    <RecoveryPassword
      dataForm={dataForm}
      onSubmit={onSubmit}
      dataFormCode={dataFormCode}
      onSubmitCode={onSubmitCode}
      errorMessage={errorMessage}
      code={code}
      goBack={goBack}
    />
  )
}

export default MakeRecoveryPassword
